var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { LogoSpotifyForArtists } from '@spotify-internal/encore-web/core';
import styled from 'styled-components';
import { flyoutTransitionMixin } from '../FlyoutMenu/config';
export var S4ALogo = styled(LogoSpotifyForArtists)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  fill: ", ";\n"], ["\n  ", "\n  fill: ", ";\n"])), flyoutTransitionMixin('fill'), function (props) { return props.theme.text; });
var templateObject_1;
